import React, { Fragment, useState } from 'react';
import { Link } from 'react-router-dom';
import {
    defaultPageSize,
    pageSizeOptions,
    showSizeChanger,
    AsumsiIcon,
    IColumnProps, Tooltip, Table, Confirm
} from 'asumsi-components';
import { IResponseLandingPage } from '@interfaces/iresponse-landing-page';
import moment from "moment";

export default function (props: any) {
    const { dataSource, metaData, onTableChange, loading } = props;
    const [showConfirmation, setShowConfirm] = useState(false);
    const [deleteId, setDeleteId] = useState();

    const showConfirm = async (e: any) => {
        e.preventDefault();
        setDeleteId(e.target.id);
        setShowConfirm(true);
    };

    const columns: IColumnProps[] = [
        {
            dataIndex: 'no',
            key: 'no',
            title: 'NO',
            textAlign: "left",
            alignData: "left",
            columnWidht: "5%",
            render: (text: string, record: IResponseLandingPage, index: number) => index + 1
        },
        {
            dataIndex: 'title',
            key: 'title',
            title: 'TITLE',
            sorter: true,
            columnWidht: "20%",
        },
        {
            dataIndex: 'slug',
            key: 'slug',
            title: 'SLUG URL',
            sorter: true,
            columnWidht: "20%",
        },
        {
            dataIndex: 'checkPointType',
            key: 'checkPointType',
            title: 'TIMELINE TYPE',
            sorter: false,
            render: (text: string) => `${text} Point Timeline`
        },
        {
            dataIndex: 'topicName',
            key: 'topicName',
            title: 'TOPIC',
            sorter: false,
        },
        {
            dataIndex: 'publishedAt',
            key: 'publishedAt',
            title: 'PUBLISHED DATE',
            sorter: true,
            render: (text: string) => text ? moment(text).format('DD MMM yyyy') : null
        },
        {
            dataIndex: 'status',
            key: 'status',
            title: 'Status',
            sorter: true,
        },
        {
            columnWidht: "8%",
            dataIndex: 'action',
            key: 'action',
            alignData: 'left',
            render: (text: string, record: IResponseLandingPage) => {
                return (
                    <div className="bt-table__action">
                        <Tooltip text="edit">
                            <Link to={`/article/landing-page/form/${record.id}`} style={{ marginRight: "8px" }}>
                                <AsumsiIcon icon="annotation" />
                            </Link>
                        </Tooltip>
                        <Tooltip text="hapus">
                            <Link to="" style={{ marginRight: "5px" }}>
                                <AsumsiIcon id={record.id} onClick={showConfirm} icon="trash" />
                            </Link>
                        </Tooltip>
                    </div>
                );
            },
            title: 'Action',
        },
    ];

    return (
        <Fragment>
            <Table columns={columns}
                upperCaseTitle={true}
                dataSource={dataSource}
                className="asumsi-table"
                loading={loading}
                pagination={{
                    currentPage: metaData ? metaData.page : 1,
                    defaultPageSize: metaData ? metaData.limit : defaultPageSize,
                    pageSizeOptions,
                    showSizeChanger,
                    total: metaData ? metaData.totalRecords : 0,
                }}
                rowKey="id"
                onChange={onTableChange}
            ></Table>
            <Confirm
                key="confirm-delete"
                loading={loading}
                show={showConfirmation}
                setShow={setShowConfirm}
                onOk={async () => {
                    await props.deleteData(deleteId);
                    props.fetchDataList();
                }}
                content='Apakah anda yakin akan menghapus data ini?'
                title='Konfirmasi'
                okText='Delete'
            />
        </Fragment>
    );
}



// WEBPACK FOOTER //
// ./src/pages/landing-page/libraries/table.tsx